import { isNullOrUndefined } from "./any";
import { normalizeString } from "./strings";

export const ObjectIdEmpty = "000000000000000000000000";

export function isObjectIdEmpty(objectId: string | null | undefined): boolean {
  return objectId === ObjectIdEmpty;
}

export function isObjectId(objectId: string | null | undefined): boolean {
  return !isNullOrUndefined(objectId) && /^[0-9a-fA-F]{24}$/.test(objectId);
}

export function isObjectIdValid(objectId: string | null | undefined): boolean {
  return isObjectId(objectId) && !isObjectIdEmpty(objectId);
}

export const normalizeObjectId = (value: unknown, fallback = ""): string => {
  const normalized = normalizeString(value);
  return isObjectId(normalized) ? normalized : fallback;
};

export const normalizeObjectIdList = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return [];
  }
  const ids = value.map(entry => normalizeObjectId(entry)).filter(id => id.length > 0 && !isObjectIdEmpty(id));
  return Array.from(new Set(ids));
};
